import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TermosTexto from "./TermosTexto";
import "../estilo.css";

export default function Rodape() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <footer className="quantum-footer">
        <div className="footer-content container-fluid">
          <div className="row">
            <div className="col-sm-4 footer-section">
              <img
                src={require("../img/QuantumEA.png")}
                alt="Quantum Trades"
                className="footer-logo"
              />
              <p className="footer-description">{t('footer.description')}</p>

              <div style={{ marginTop: "16px" }}>
                <Link to="/planos" className="footer-link" style={{ display: "inline-block", marginRight: "14px" }}>
                  {t('footer.viewPlans')}
                </Link>
                <Link to="/cadastro" className="footer-link" style={{ display: "inline-block" }}>
                  {t('footer.createAccount')}
                </Link>
              </div>
            </div>

            <div className="col-sm-4 footer-section">
              <h4>{t('footer.navigation')}</h4>
              <ul className="footer-links">
                <li><Link to="/">{t('nav.home')}</Link></li>
                <li><Link to="/planos">{t('nav.plans')}</Link></li>
                <li><Link to="/indicadores">{t('nav.indicators')}</Link></li>
                <li><Link to="/portifolio">{t('nav.portfolio')}</Link></li>
                <li><Link to="/cadastro">{t('nav.register')}</Link></li>
                <li><Link to="/contato">{t('nav.contact')}</Link></li>
              </ul>
            </div>

            <div className="col-sm-4 footer-section">
              <h4>{t('footer.contact')}</h4>
              <p>Email: <a href="mailto:contato@quantumtrades.com.br">contato@quantumtrades.com.br</a></p>
              <p>WhatsApp: <a href="https://wa.me/5542984241307" target="_blank" rel="noreferrer">(42) 98424-1307</a></p>
              <p>YouTube: <a href="https://www.youtube.com/@QuantumTradesBR" target="_blank" rel="noreferrer" className="footer-link">@QuantumTradesBR</a></p>
              <p>Telegram: <a href="https://t.me/QuantumTradesBr" target="_blank" rel="noreferrer" className="footer-link">@QuantumTradesBR</a></p>

              <div className="telegram-qrcode-wrapper">
                <img
                  src={require("../img/LinkTelegramQuantemTradesBR.png")}
                  alt={t('footer.telegramAlt')}
                  className="telegram-qrcode-small"
                />
              </div>
            </div>
          </div>

          <div
            style={{
              marginTop: "30px",
              paddingTop: "22px",
              borderTop: "1px solid rgba(255,255,255,0.08)",
              textAlign: "center",
            }}
          >
            <p className="footer-terms" style={{ marginTop: 0 }}>{t('footer.risk')}</p>

            <div style={{ marginTop: "10px" }}>
              <button className="footer-terms-btn" onClick={() => setOpen(true)}>
                {t('footer.readTerms')}
              </button>
            </div>

            <p className="footer-copy">
              {t('footer.copyright', { year: new Date().getFullYear() })}
            </p>
          </div>
        </div>
      </footer>

      {open && (
        <div className="termos-modal-overlay" onClick={() => setOpen(false)}>
          <div className="termos-modal" onClick={(e) => e.stopPropagation()}>
            <h3>{t('footer.termsTitle')}</h3>
            <div className="termos-text">
              <TermosTexto />
            </div>
            <button className="footer-terms-btn" onClick={() => setOpen(false)}>
              {t('common.close')}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
